import React from 'react';

interface TooltipWrapperProps {
    /** The content to be wrapped with a tooltip */
    children: React.ReactNode;
    /** The tooltip content to show when hovering */
    tooltipContent?: string;
    /** Whether the tooltip should be shown */
    showTooltip?: boolean;
}

/**
 * A wrapper component that adds a native browser tooltip to its children.
 * The tooltip is only shown when showTooltip is true and tooltipContent is provided.
 */
const TooltipWrapper = ({ children, tooltipContent, showTooltip = true }: TooltipWrapperProps) => { 
    if (!showTooltip || !tooltipContent) {
        return <>{children}</>;
    }

    return (
        <span title={tooltipContent}>
            {children}
        </span>
    );
};

export default TooltipWrapper; 